<!--
 * @Author: your name
 * @Date: 2020-08-03 14:10:23
 * @LastEditTime: 2020-08-08 15:55:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/pages/form/form-widget-table/form-widget-table.vue
-->
<template>
  <div class="form-widget-table">
    <div class="search-bar">
      <x-input-search @search="doSearch"></x-input-search>
    </div>
    <div ref="listDom" class="list" @scroll="handleScroll">
      <div v-for="(item, index) in computedRenderTableData" :key="item.id" class="card-item">
        <form-list-card
          :columns="computedRenderCols"
          :data="item"
          :inTable="true"
          @view-detail="viewDetail($event, index)"
        ></form-list-card>
      </div>
      <x-empty v-if="showEmpty"></x-empty>
    </div>
    <!-- <div class="form-footer">
      <div class="form-footer-content">
        <div class="form-footer--btns">
          <cube-button
            :light="true"
            :inline="true"
            :primary="true"
            @click="handleConfirm">
            确定
          </cube-button>
        </div>
      </div>
    </div> -->
    <div
      v-if="!compPayload[compPayloadKey].widgetConfig.readOnly"
      class="list-add-icon active-style"
      @click="handleCreate"
    >
      <x-svg-icon name="add"></x-svg-icon>
    </div>
  </div>
</template>

<script>
import FormListCard from '@/lib/ui/components/form/form-list-card'
import { mapState, mapMutations } from 'vuex'
import {
  SET_COMP_VALUE,
  SET_COMP_PAYLOAD,
  CLEAR_COMPROUTER_STORE
} from '@/store/comp-router.store.js'
import ScrollBehaviorMixin from '@/mixin/scroll-behavior.mixin'

export default {
  name: 'WidgetTable',
  components: {
    FormListCard
  },
  mixins: [ScrollBehaviorMixin],
  inject: ['addKeepAlive', 'removeKeepAlive'],
  provide() {
    return {
      $compRouter: {
        push: this.compRouterPush
      }
    }
  },
  data() {
    return {
      compPayloadKey: this.$route.query.key,
      len: 4,
      tableData: [],
      keyword: ''
    }
  },
  computed: {
    ...mapState({
      compPayload: (state) => state.compRouterModule.compPayload
    }),
    computedRenderCols() {
      return this.compPayload[this.compPayloadKey].widgetConfig.tableColumn.filter((col) => {
        return !col.hidden
      }).slice(0, this.len)
    },
    computedRenderTableData() {
      if (this.keyword) {
        return this.tableData.map((item) => {
          let flag = false
          for (const col of this.computedRenderCols) {
            if (col.componentType === 'FORM_DATA_SELECTOR') {
              const values = Array.isArray(item[col.uuid]) ? item[col.uuid] : [item[col.uuid]]
              if (values.filter(value => value.name.indexOf(this.keyword) > -1).length > 0) {
                flag = true
                break
              }
            } else if (['FORM_RADIO_INPUT', 'FORM_CHECKBOX_INPUT', 'FORM_SELECT_INPUT'].includes(col.componentType)) {
              const values = item[col.uuid]
              const opts = col.chooseOptions.map((op) => {
                if (values.includes(op.id)) {
                  return op
                }
              }).filter(temp => !!temp)
              if (opts.filter(value => value.label.indexOf(this.keyword) > -1).length > 0) {
                flag = true
                break
              }
            } else if (col.componentType === 'FORM_PEOPLE_SELECT') {
              const values = item[col.uuid]
              if (values.filter(value => value.username.indexOf(this.keyword) > -1).length > 0) {
                flag = true
                break
              }
            } else if (col.componentType === 'FORM_DEPARTMENT_SELECT') {
              const values = item[col.uuid]
              if (values.filter(value => value.name.indexOf(this.keyword) > -1).length > 0) {
                flag = true
                break
              }
            } else {
              const value = String(item[col.uuid])
              if (value && value.indexOf(this.keyword) > -1) {
                flag = true
                break
              }
            }
          }
          if (flag) {
            return item
          }
        }).filter((item) => !!item)
      } else {
        return this.tableData
      }
    },
    showEmpty: function () {
      return (!this.computedRenderTableData || this.computedRenderTableData.length === 0)
    },
    formData() {
      return this.compPayload[this.compPayloadKey].formData
    }
  },
  created() {
    if (this.compPayload[this.compPayloadKey].value instanceof Array) {
      this.tableData = this.$lodash.cloneDeep(this.compPayload[this.compPayloadKey].value)
    }
  },
  activated() {
    if (this.compPayload) {
      this.removeKeepAlive(this.$options.name)
      if (!this.compPayload[this.compPayload.activeKey].value) {
        return
      }
      const keys = this.compPayload.activeKey.split('.')
      if (keys.length > 1) { // 表格
        if (keys[1] === 'add') {
          if (this.compPayload[this.compPayload.activeKey].value.$deleted) {
            return
          }
          let tableData = this.tableData
          if (!tableData) {
            tableData = []
          }
          tableData.unshift(this.compPayload[this.compPayload.activeKey].value)
          this.$set(this.$data, 'tableData', tableData)
          this.clearCompRoterStore(this.compPayload.activeKey)
        } else {
          const index = Number(keys[1])
          const compPayloadValue = this.compPayload[this.compPayload.activeKey].value
          if (compPayloadValue.$deleted) {
            let tableData = this.tableData
            if (tableData) {
              tableData.splice(index, 1)
              this.$set(this.$data, 'tableData', tableData)
            }
          } else {
            this.$set(this.tableData, index, compPayloadValue)
          }
          this.$set(this.$data, 'tableData', this.tableData)
          this.tableData = [ ...this.tableData ]
          this.clearCompRoterStore(this.compPayload.activeKey)
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.handleConfirm()
    next(true)
  },
  methods: {
    ...mapMutations('compRouterModule', {
      setCompValue: SET_COMP_VALUE,
      setCompPayload: SET_COMP_PAYLOAD,
      clearCompRoterStore: CLEAR_COMPROUTER_STORE
    }),
    doSearch(e) {
      this.keyword = e
    },
    compRouterPush(compName, compPayload) {
      this.setCompPayload(compPayload) // key widgetConfig value
      this.addKeepAlive(this.$options.name)
      this.$nextTick(() => {
        this.$router.push({
          name: compName,
          params: {
            id: 'all'
          },
          query: {
            appId: this.$route.query.appId,
            key: compPayload.key,
            formId: this.$route.query.formId,
            documentId: this.$route.query.documentId,
            inTable: compPayload.inTable,
            tableUUID: compPayload.tableUUID
          }
        })
      })
    },
    handleCreate() {
      this.compRouterPush('TableItemDetail', {
        key: `${this.compPayload[this.compPayloadKey].widgetConfig.uuid}.add`,
        widgetConfig: this.compPayload[this.compPayloadKey].widgetConfig,
        inTable: true,
        tableUUID: this.compPayload[this.compPayloadKey].widgetConfig.uuid
      })
    },
    viewDetail(e, index) {
      this.compRouterPush('TableItemDetail', {
        key: `${this.compPayload[this.compPayloadKey].widgetConfig.uuid}.${index}`,
        widgetConfig: this.compPayload[this.compPayloadKey].widgetConfig,
        value: e,
        inTable: true,
        formData: this.formData,
        tableUUID: this.compPayload[this.compPayloadKey].widgetConfig.uuid
      })
    },
    handleConfirm() {
      this.setCompValue({
        key: this.$route.query.key,
        value: this.$lodash.cloneDeep(this.tableData)
      })
      // this.$router.go(-1)
    },
    scrollToY(y) {
      this.$refs.listDom.scrollTop = y
    }
  }
}
</script>

<style lang="scss">
.form-widget-table {
  height: 100%;
  display: flex;
  flex-flow: column;
  .list {
    flex: 1;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0.57rem 1.14rem;
    background-color: $--app-body-bgColor;
    box-sizing: border-box;
    .list-card {
      margin-bottom: 0.57rem;
    }
  }
  .list-add-icon {
    width: 2.857rem;
    height: 2.857rem;
    position: absolute;
    right: 1.071rem;
    bottom: 5.3%;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: $--app-light-color;
    background-color: $--app-primary-color;
    .x-svg-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .form-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: $--app-light-color;
    border-top: 1PX solid $--app-body-bgColor;
    .form-footer-header {
      padding: .5rem;
      .form-footer-idea--textarea {
        min-height: 6.14rem;
        max-height: 6.14rem;
        &.cube-textarea-wrapper::after {
          border: 0;
        }
      }
    }
    .form-footer-content {
      display: flex;
      align-items: center;
      height: 3.428rem;
      .form-footer--ops {
        position: relative;
        display: flex;
        justify-content: flex-end;
        flex: 0 0 2.86rem;
        color: $--app-primary-color;
        margin-left: 0.57rem;
        .ops-content {
          display: flex;
          flex-direction: column;
          position: absolute;
          bottom: 100%;
          left: 0;
          width: 7rem;
          border-radius: $--app-base-border-radius;
          background-color: $--app-box-bgColor;
          z-index: 100;
          box-shadow: $--app-box-shadow;
          box-sizing: border-box;
          .ops-content-item {
            flex: 1;
            display: flex;
            align-items: center;
            height: 2.5rem;
            padding: 0.285rem;
            > span {
              font-size: $--app-base-font-size;
              flex: 1;
              margin: 0 0.285rem;
            }
          }
        }
      }
      .form-footer--btns {
        display: flex;
        justify-content: flex-end;
        flex: 1;
      }
    }
    .cube-btn {
      margin-right: 1.142rem;
      width: 4.571rem;
      height: 2.285rem;
    }
  }
}
</style>
